import { ADD_ROLES } from './types'

export const addRoles = roles => ({
  type: ADD_ROLES,
  payload: { roles }
})
